<template>
  <main class="support-project-page">
    <section class="support-project-hero" v-reveal>
      <div>
        <p class="section-kicker">{{ support.kicker }}</p>
        <h1>{{ support.title }}</h1>
        <p>{{ support.copy }}</p>
        <div class="hero-actions">
          <a class="action-button action-button--discord action-button--large" :href="support.primaryAction.href">
            <AppIcon :name="support.primaryAction.icon" />
            <span>{{ support.primaryAction.label }}</span>
          </a>
          <a class="action-button action-button--muted action-button--large" :href="support.secondaryAction.href">
            <AppIcon :name="support.secondaryAction.icon" />
            <span>{{ support.secondaryAction.label }}</span>
          </a>
        </div>
      </div>

      <PageMascotVisual />
    </section>

    <section class="support-project-note" v-reveal>
      <span><AppIcon name="info" /></span>
      <div>
        <p class="section-kicker">{{ support.noteKicker }}</p>
        <h2>{{ support.noteTitle }}</h2>
        <p>{{ support.noteCopy }}</p>
      </div>
    </section>

    <section class="support-project-options" v-reveal>
      <article v-for="item in support.options" :key="item.title">
        <span><AppIcon :name="item.icon" /></span>
        <div>
          <h2>{{ item.title }}</h2>
          <p>{{ item.copy }}</p>
        </div>
        <a :href="item.href">{{ item.action }}</a>
      </article>
    </section>

    <section class="support-project-impact" v-reveal>
      <div>
        <p class="section-kicker">{{ support.impactKicker }}</p>
        <h2>{{ support.impactTitle }}</h2>
      </div>
      <ul>
        <li v-for="item in support.impact" :key="item">
          <AppIcon name="star" />
          <span>{{ item }}</span>
        </li>
      </ul>
    </section>
  </main>
</template>

<script>
import AppIcon from './AppIcon.vue'
import PageMascotVisual from './PageMascotVisual.vue'

export default {
  name: 'SupportProjectPage',
  components: {
    AppIcon,
    PageMascotVisual
  },
  props: {
    support: {
      type: Object,
      required: true
    }
  }
}
</script>
